import { IClientUserAssociation } from 'store/entities/users/model';
import { createRequestActions, RequestType } from 'store/utils';

export const getClientManagersAction = createRequestActions<void, IClientUserAssociation[]>(
    RequestType.Get,
    'CLIENT_MANAGERS',
    'users/managers',
);
